const Frank = {
  jobTitle: "Software Engineer Intern",
  company: "Frank by OCBC",
  duration: "May 2021 - Jul 2021",
  description:
    "Developed microservice features related to stock search and fact sheets for OCBC Digital App as a Back-End Engineer under the OCBC@STEM Programme",
  jobscope: [
    "Developed microservices related to stock search and fact sheets using Java Spring Boot MVC framework",
    "Worked with RESTful & GraphQL API services",
  ],
  funFact:
    "The office was really small but it was designed with street art with graffiti murals all over the place, very cool!",
};

export default Frank;
